import React, { useEffect, useRef, useState } from 'react'
import Header from '../layout/Header'
import { formatDatee } from '../../helpers/converter'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getApplications } from '../../actions/application/getApplications'
import { pagingApplicationNurse } from '../../actions/nurse/pagingApplicationNurse'
import { applicationNoteFullHistory, resetApplicationNoteFullHistory } from '../../actions/nurse/applicationNoteFullHistory'
import { addNoteToApplication } from '../../actions/nurse/addNoteToApplication'
import { formatZuluTime } from '../../helpers/formatter'
import Swal from 'sweetalert2'

function NoteDetail(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { Id } = useParams();
    const [message, setMessage] = useState('');
    const user = JSON.parse(localStorage.getItem('user'));
    const { patientName } = useParams();

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        dispatch(applicationNoteFullHistory(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (props.addNoteToApplication.done) {
            setMessage('');
            dispatch(applicationNoteFullHistory(Id));
        }
    }, [props.addNoteToApplication, dispatch, Id]);

    const sortedNotes = props.applicationNoteFullHistory?.applicationNoteFullHistory?.result?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    useEffect(() => {
        scrollToBottom();
    }, [sortedNotes]);

    useEffect(() => {
        dispatch(applicationNoteFullHistory(Id))
    }, [dispatch])

    useEffect(() => {

        if (props.addNoteToApplication.done) {
            dispatch(applicationNoteFullHistory(Id))
        }

    }, [props.addNoteToApplication])

    useEffect(() => {
        if (props.applicationNoteFullHistory.error != false) {
            Swal.fire({
                icon: 'error',
                title: 'Erişim yetkisi!',
                text: 'Bu sayfaya erişim yetkiniz bulunmamaktadır.',
                confirmButtonText: 'Anladım'
            }).then((result) => {
                dispatch(resetApplicationNoteFullHistory());
                navigate('/application-results')
            })
        }
    }, [props.applicationNoteFullHistory])

    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">

                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Başvuru notları - {patientName}
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <div className='relative mt-5 ps-5 pe-5 md:ml-64 mb-20 '> {/* mb-20, input alanı için altta yer açar */}
                <ul className="space-y-5 text-start overflow-y-auto max-h-[calc(100vh-200px)]"> {/* Ekran yüksekliğine bağlı dinamik max-height */}
                    {sortedNotes?.map((note, index) => {
                        const isUserMessage = note?.userId === user?.id;
                        return (
                            <li key={note.id} className={`me-10 flex  ${isUserMessage ? 'justify-end' : 'justify-start'}`}>
                                <div
                                    ref={messagesEndRef}
                                    className={`max-w-lg ${isUserMessage ? 'flex-row-reverse' : 'flex-row'} gap-x-2 sm:gap-x-4 overflow-hidden`}>
                                    <div
                                        className={`border border-gray-200 rounded-2xl p-4 space-y-3
                                        ${isUserMessage ? 'bg-blue-600 text-white' :
                                                note.commentSource === 0 ? `bg-[#CEF3DE] dark:bg-slate-900 dark:border-gray-700` :
                                                    note.commentSource === 1 ? `bg-[#9DE7BE] dark:bg-slate-900 dark:border-gray-700` :
                                                        note.commentSource === 2 ? `bg-[#6BDB9D] dark:bg-slate-900 dark:border-gray-700` :
                                                            note.commentSource === 3 ? `bg-[#3ACF7D] dark:bg-slate-900 dark:border-gray-700` :
                                                                null}`}>
                                        <p>
                                            {note.commentSource === 0 ? '' :
                                                note.commentSource === 1 ? 'Doktor' :
                                                    note.commentSource === 2 ? 'Başvuran' :
                                                        note.commentSource === 3 ? 'Hemşire' : null}
                                            &nbsp;
                                            {note.commentOwnerFullName}</p>
                                        <p
                                            className={`text-sm ${isUserMessage ? 'text-white' : 'text-gray-800 dark:text-white'} break-words overflow-wrap`}>
                                            {note.text}
                                        </p>
                                        <div
                                            className={`text-xs ${isUserMessage ? 'text-white' : 'text-gray-800'} text-right`}>
                                            {formatDatee(note.createdAt)}
                                            <br />
                                            {formatZuluTime(note.createdAt)}

                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className='fixed bottom-0 left-0 right-0 md:ml-64 ps-5 pe-5 pb-5 bg-white dark:bg-slate-900'> {/* Arka plan rengi eklendi */}
                <div className="flex flex-row justify-between">
                    <textarea
                        rows={3}
                        onChange={(e) => setMessage(e.target.value)}
                        type="text"
                        value={message}
                        className="me-2 py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                        placeholder="İletmek istediğiniz notu girin..."
                    />
                    <button
                        onClick={() => {
                            if (message.trim()) {
                                dispatch(addNoteToApplication(Id, message));
                                setMessage('');
                            } else {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Boş mesaj',
                                    text: 'Lütfen bir not girin.',
                                    confirmButtonText: 'Tamam'
                                });
                            }
                        }}
                        type="button"
                        disabled={!message.trim()}
                        className={`ms-2 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border ${!message.trim()
                            ? 'border-gray-300 text-gray-300 cursor-not-allowed'
                            : 'border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800'
                            } dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600`}
                    >
                        <i className="fa-sharp fa-solid fa-paper-plane-top"></i>
                    </button>
                </div>
            </div>


        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(NoteDetail);